module.exports = __webpack_public_path__ + "img/member02.0d6bff35.png";